import {createContext} from 'react'

export const ServicePaymentContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  servicePayments: [],
  setServicePayments: () => {
  },
  servicePayment: {
    id: null,
    service_id: null,
    person_name: "",
    person_phone: "",
    agent_name: "",
    agent_phone: "",
    branch_name: "",
    total: null,
    settled_amount: null,
    canceled_amount: null,
    remaining_amount: null,
    payment_type: "",
    two_step_payment: false,
    settlement_status: "",
    milestones: [],
  },
  setServicePayment: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
})
